/**
 * 机器人 API
 */

import apiClient from './client';

export interface Robot {
  id: string;
  robot_ak: string;
  robot_name: string;
  robot_identifier?: string;
  web_hook?: string;
  session_limit: number;
  status: 'active' | 'pending' | 'kicked';
  joined_at: string;
  last_active?: string;
  last_heartbeat?: string;
  session_stats?: {
    total_used: number;
    remaining: number;
  };
}

export interface AddRobotRequest {
  group_id: string;
  robot_name: string;
  robot_identifier?: string;
  session_limit?: number;
}

export interface AddRobotResponse {
  id: string;
  robot_ak: string;
  group_id: string;
  group_name: string;
  joined_at: string;
}

/**
 * 添加机器人到群组
 */
export async function addRobotToGroup(data: AddRobotRequest): Promise<AddRobotResponse> {
  const response = await apiClient.post('/robots', data);
  return response.data;
}

/**
 * 踢除机器人
 */
export async function kickRobot(robotId: string): Promise<void> {
  await apiClient.delete(`/robots/${robotId}`);
}

/**
 * 设置会话限制
 */
export async function setSessionLimit(robotId: string, limit: number): Promise<void> {
  await apiClient.put(`/robots/${robotId}/session-limit`, {
    session_limit: limit,
  });
}

/**
 * 重置会话计数
 */
export async function resetCount(robotId: string): Promise<void> {
  await apiClient.post(`/robots/${robotId}/reset-count`, {
    confirm: true,
  });
}

/**
 * 设置 Webhook
 */
export async function setWebhook(robotId: string, url: string): Promise<void> {
  await apiClient.put(`/robots/${robotId}/webhook`, {
    web_hook: url,
  });
}

/**
 * 测试 Webhook
 */
export async function testWebhook(robotId: string): Promise<any> {
  const response = await apiClient.post(`/robots/${robotId}/webhook/test`);
  return response.data;
}

/**
 * 更新机器人信息
 */
export async function updateRobot(robotId: string, data: {
  robot_name?: string;
  robot_identifier?: string;
  session_limit?: number;
  web_hook?: string;
}): Promise<any> {
  const response = await apiClient.put(`/robots/${robotId}`, data);
  return response.data;
}

/**
 * 审批通过机器人
 */
export async function approveRobot(robotId: string): Promise<void> {
  await apiClient.post(`/robots/${robotId}/approve`);
}

/**
 * 拒绝机器人申请
 */
export async function rejectRobot(robotId: string): Promise<void> {
  await apiClient.post(`/robots/${robotId}/reject`);
}
